import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "advanced-reporting"
    }}>{`Advanced reporting`}</h1>
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce-admin/start/reporting/business-intelligence#advanced-reporting"
      }}>{`Advanced reporting functionality`}</a>{` is free to Adobe Commerce and Magento Open Source customers and is provided through an integration with `}<a parentName="p" {...{
        "href": "https://business.adobe.com/products/magento/business-intelligence.html"
      }}>{`Adobe Commerce Reporting`}</a>{`. The `}<a parentName="p" {...{
        "href": "../../module-reference/module-analytics.md"
      }}>{`Analytics`}</a>{` module collects and sends data to Adobe Commerce Reporting. However, you do not need to have an Adobe Commerce Reporting account to use the Analytics module.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`If you encounter problems with Advanced Reporting, try the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/en/docs/commerce-knowledge-base/kb/troubleshooting/miscellaneous/magento-advanced-reporting-troubleshooter"
      }}>{`troubleshooter`}</a>{` in the `}<em parentName="p">{`Adobe Commerce Knowledge Base`}</em>{`.`}</p>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ol>
      <li parentName="ol">{`The website must run on a public web server.`}</li>
      <li parentName="ol">{`The domain must have a valid security (SSL) certificate.`}</li>
      <li parentName="ol">{`Adobe Commerce or Magento Open Source must have been installed or upgraded successfully without error.`}</li>
      <li parentName="ol">{`In the Adobe Commerce or Magento Open Source configuration, the `}<a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/en/docs/commerce-admin/stores-sales/site-store/store-urls"
        }}>{`Base URL (Secure) setting`}</a>{` for the store view must point to the secure URL. For example `}<inlineCode parentName="li">{`https://yourdomain.com`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`In the Adobe Commerce or Magento Open Source configuration, `}<strong parentName="li">{`Use Secure URLs on Storefront`}</strong>{`, `}<strong parentName="li">{`and Use Secure URLs in Admin`}</strong>{` must be set to `}<strong parentName="li">{`Yes`}</strong>{`.`}</li>
      <li parentName="ol">{`Make sure that the `}<a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/en/docs/commerce-operations/configuration-guide/cli/configure-cron-jobs"
        }}>{`crontab`}</a>{` is created and cron jobs are running on the installed server.`}</li>
    </ol>
    <p>{`The merchant can now click on the `}<strong parentName="p">{`Go to Advanced Reporting`}</strong>{` button on the Admin dashboard to launch the advanced reporting features.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`It can take up to a day for data to be available in Advanced Reporting.`}</p>
    <h2 {...{
      "id": "recommendations"
    }}>{`Recommendations`}</h2>
    <p>{`To avoid system overload during its prime time, you can set the preferable time of a day for a data collection.`}</p>
    <h2 {...{
      "id": "extensibility"
    }}>{`Extensibility`}</h2>
    <p>{`Though the Analytics module provides an API, it is used specifically to interchange data with Adobe Commerce Reporting. Adobe does not recommend extending the advanced reporting functionality.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      